import { Box, InputBase, makeStyles } from '@material-ui/core';

import { useCustomTheme } from '../../../../../hooks/useCustomTheme';
import { Font } from '../../../../shared/components/Font';
import { useTranslation } from '../../../../shared/hooks/useTranslation';

interface UserSearchProps {
  userType: 'agent' | 'channel';
  onSearch: (searchTerm: string) => void;
  onKeyDown: (key: string) => void;
  hideEndAdornment?: boolean;
}

export const UserSearch = ({ userType, onSearch, onKeyDown, hideEndAdornment = false }: UserSearchProps) => {
  const { palette, typography } = useCustomTheme();
  const { getTextIdTranslation } = useTranslation();

  const useStyles = makeStyles({
    root: {
      '& .MuiInputBase-input': {
        fontSize: typography.body2.fontSize,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
  });

  const classes = useStyles();

  const getParamsByType = (userType: UserSearchProps['userType']) => {
    switch (userType) {
      case 'agent':
        return {
          id: 'agentSearch',
          title: 'SEARCH_AGENT',
        };
      case 'channel':
        return {
          id: 'channelSearch',
          title: 'SEARCH_CHANNEL',
        };
      default:
        break;
    }
  };

  if (!userType) return null;

  const params = getParamsByType(userType);

  return (
    <Font variant={'caption'} color={'textSecondary'}>
      <InputBase
        onKeyDown={(e) => onKeyDown(e.key)}
        onChange={(e) => onSearch(e.target.value)}
        classes={{ root: classes.root }}
        placeholder={`${getTextIdTranslation(params.title)}`}
        id={'searchTerm'}
        name={'searchTerm'}
        style={{ width: '100%' }}
        startAdornment={
          <i
            className="material-icons-outlined mr-2"
            style={{ verticalAlign: 'text-top', fontSize: '22px', color: palette.text.secondary }}
          >
            search
          </i>
        }
        endAdornment={
          !hideEndAdornment && (
            <Box
              display={'flex'}
              alignItems={'center'}
              border={`solid 1px ${palette.text.secondary}`}
              borderRadius={'4px'}
              padding={'2px 4px'}
            >
              <i
                className="material-icons-outlined mr-2"
                style={{
                  verticalAlign: 'text-top',
                  fontSize: '14px',
                  color: palette.text.secondary,
                  marginRight: '4px',
                }}
              >
                keyboard_return
              </i>
              <Font variant={'caption'} style={{ color: palette.text.secondary }}>
                Enter
              </Font>
            </Box>
          )
        }
      />
    </Font>
  );
};
